import * as React from 'react';

const useKeyPress = function(targetKey, ref2) {
    const [keyPressed, setKeyPressed] = React.useState(false);
    const downHandler = ({ code  })=>{
        if (code === targetKey) {
            setKeyPressed(true);
        }
    };
    const upHandler = ({ code  })=>{
        if (code === targetKey) {
            setKeyPressed(false);
        }
    };
    React.useEffect(()=>{
        var ref4, ref1;
        (ref4 = ref2.current) === null || ref4 === void 0 ? void 0 : ref4.addEventListener('keydown', downHandler);
        (ref1 = ref2.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener('keyup', upHandler);
        return ()=>{
            var ref, ref3;
            (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.removeEventListener('keydown', downHandler);
            (ref3 = ref2.current) === null || ref3 === void 0 ? void 0 : ref3.removeEventListener('keyup', upHandler);
        };
    }, []);
    return keyPressed;
};

export { useKeyPress as default };
//# sourceMappingURL=use-key-press.js.map
